import { defineDocument } from '../../schema';
export const blogNewYearNewGamesStreamGamesToEarnSubsDocument = defineDocument({
    id: 'blog:new-year-new-games-stream-games-to-earn-subs',
    kind: 'blog',
    slug: 'new-year-new-games-stream-games-to-earn-subs',
    route: '/blog/new-year-new-games-stream-games-to-earn-subs',
    seo: {
        title: 'New Year, New Games: Stream Games to Earn Subs',
        description: 'Looking back on a transformative 2025 and announcing our biggest streamer campaign yet',
        imageAsset: 'heroNYNG',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'New Year, New Games: Stream Games to Earn Subs',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Looking back on a transformative 2025 and announcing our biggest streamer campaign yet',
            },
        ],
        imageAsset: 'heroNYNG',
        imageAlt: 'New Year New Games Campaign',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-01-11T00:00:00.000Z'),
        tags: ['news'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The year 2025 changed everything for Airhead Games. Now we\'re kicking off 2026 with "New Year, New Games" - our biggest campaign yet. It\'s simple: play games on stream to earn Twitch subs for your channel.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__reflecting-on-2025',
                    title: [
                        {
                            type: 'text',
                            text: 'Reflecting on 2025',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'I want to take a moment to say thank you. The Airhead Games beta launched in April 2025 with just a few crude games and a dream to make party games endlessly replayable. By September, we had ',
                                },
                                {
                                    type: 'link',
                                    href: '/blog/airhead-games-officially-launches',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'completely rebuilt the platform',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' from the ground up.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Since then, our game library has grown to seven original games, each with its own personality and soundtrack. Our ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/music',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'music catalog',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' has exploded to almost 100 unique tracks. Most importantly, Airhead Games has brought joy to players around the world.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Seeing people connect and laugh together has been incredibly rewarding. In 2026, our ambition is to bring smiles to exponentially more people.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__the-campaign',
                    title: [
                        {
                            type: 'text',
                            text: 'The Campaign',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'New Year, New Games runs from January 16-25, 2026. The core mechanic is simple: ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'earn one Twitch sub for every three games you complete',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " while streaming. There's no cap on how many you can earn.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Beyond the base earnings, there are bonus opportunities for playing all seven games, topping the leaderboard for any single game, and capturing the best moments on stream. Full details and live stats are on the ',
                                },
                                {
                                    type: 'link',
                                    href: '/campaigns/new-year-new-games',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'campaign page',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__why-we-are-doing-this',
                    title: [
                        {
                            type: 'text',
                            text: 'Why We Are Doing This',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Airhead Games is a new indie platform built by a solo developer. Real streamers stress-testing our games and telling us what works (and what doesn't) is incredibly valuable at this stage in our journey. Your participation directly shapes what comes next.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'In return, Airhead Games will support your channel with subs, social posts, and opportunities to be discovered on our website.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__get-started',
                    title: [
                        {
                            type: 'text',
                            text: 'Get Started',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Let's start 2026 with a bang! ",
                                },
                                {
                                    type: 'link',
                                    href: '/campaigns/new-year-new-games#opt-in',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Opt into the campaign',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' now or head to ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: "Poppy's Pals Discord",
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' if you want to discuss the campaign with our community.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=new-year-new-games-stream-games-to-earn-subs.js.map